export const DEFAULT_TABLE_PLACEHOLDER = 'Sorry but we could not find any items';

export const DEFAULT_DRAPABLE_ID = 'tableDroppable';

export const DEBOUNCE_DELAY_MS = 200;
